import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import InsightsIcon from '@mui/icons-material/Insights';

export default function Footer() {
  return (
    <Container sx={{ py: { xs: 8, sm: 10 } }}>
      <Box
        sx={{
          p: { xs: 3, sm: 4 },
          borderRadius: '32px',
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'rgba(255,255,255,0.03)',
        }}
      >
        <Stack spacing={4}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={3}
            justifyContent="space-between"
            alignItems={{ xs: 'flex-start', md: 'center' }}
          >
            <Box>
              <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1.5 }}>
                <InsightsIcon />
                <Box>
                  <Typography fontWeight={700}>AlgoTrader</Typography>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ letterSpacing: 1.6, textTransform: 'uppercase' }}
                  >
                    Trading command center
                  </Typography>
                </Box>
              </Stack>
              <Typography color="text.secondary" sx={{ maxWidth: 520 }}>
                Monitor markets, validate strategies, and act from a cleaner trading
                workflow that now matches the product UI.
              </Typography>
            </Box>
            <Button
              variant="contained"
              component="a"
              href="https://app.algo-trader.tech/signup"
              target="_blank"
              sx={{ borderRadius: '999px', px: 2.5, py: 1.25, boxShadow: 'none' }}
            >
              Create account
            </Button>
          </Stack>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={2}
            justifyContent="space-between"
            sx={{ pt: 3, borderTop: '1px solid', borderColor: 'divider' }}
          >
            <Typography variant="body2" color="text.secondary">
              Copyright © AlgoTrader {new Date().getFullYear()}
            </Typography>
            <Stack direction="row" spacing={2} useFlexGap flexWrap="wrap">
              <Link href="https://app.algo-trader.tech" target="_blank" underline="hover">
                Sign in
              </Link>
              <Link href="https://app.algo-trader.tech/privacy" target="_blank" underline="hover">
                Privacy
              </Link>
              <Link href="https://app.algo-trader.tech/terms" target="_blank" underline="hover">
                Terms
              </Link>
              <Link href="mailto:support@algo-trader.tech" underline="hover">
                Contact
              </Link>
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Container>
  );
}
